export default __webpack_public_path__ + "media/images/load-d36dde7ac1649698afca1b6950f4011d.gif";